/* eslint camelcase: 0 */
export var PolicyMutationTypes;
(function (PolicyMutationTypes) {
    PolicyMutationTypes["FETCH_POLICIES"] = "FETCH_POLICIES";
    /** Merge into existing policies.attendances without replacing project-scoped policy state */
    PolicyMutationTypes["PATCH_ATTENDANCE_POLICIES"] = "PATCH_ATTENDANCE_POLICIES";
})(PolicyMutationTypes || (PolicyMutationTypes = {}));
